.title {
  font-size: 20px;
  font-weight: 600;
  margin: 20px 16px 10px;
}

.subtitle,
.callout {
  margin: 10px 16px;
}

.subtitle {
  font-size: 14px;
  color: var(--color-text-secondary);
}
